import { type Snapshot } from '@ember-data/store';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default class HomeawayLinkSerializer extends ApplicationSerializer {
  attrs = {
    status: { serialize: false },
    checkpoints: { serialize: false },
    contentIssues: { serialize: false },
    contentHandoverAvailable: { serialize: false },
  };

  // The API can flip `managesContent` on its own, so a record loaded before
  // that only sends the flag when the host has changed it.
  serialize(snapshot: Snapshot, options: object) {
    const json = super.serialize(snapshot, options);

    if (!('managesContent' in snapshot.changedAttributes())) {
      // @ts-expect-error - no typings for the raw JSON:API document
      delete json.data.attributes.manages_content;
    }

    return json;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'homeaway-link': HomeawayLinkSerializer;
  }
}
